import Logo from './../img/logo.png'

export default function FormHeader(){
    return(
        <div className='row mt-2'>
            <img src={Logo}  className="img-reponsive" style={{maxWidth:'800px'}} />
        </div>
    )
}